import React, { PureComponent } from 'react';
import { View, TimeStamp, Text } from 'core';
import { GROUP_ROLES, css, theme } from 'constants';
import system_types from './system_msg';
import user_types from './user_msg';
import { isSameDay } from 'date-fns';
import { lang } from 'lang';

import { getFileFromUploadsGroup } from 'selectors';
const all_types = {
  ...system_types,
  ...user_types
};

const styles = css({
  time: {
    alignSelf: 'center',
    margin: 20,
    backgroundColor: theme.warning_color_lighten(),
    height: 26,
    paddingHorizontal: 20,
    justifyContent: 'center',
    borderRadius: 13
  },
  unread_bar: {
    backgroundColor: theme.warning_color_lighten(0.1),
    borderBottomWidth: 1,
    borderBottomColor: theme.warning_color_lighten(0.4),
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 15,
    paddingVertical: 10
  },
  unread_text: {
    color: theme.gray_color_lighten(0.7)
  }
});

const renderMsg = (item, index, props, calculateOffset) => {
  const { messages, is_group, members, last_read_msg_id, unread_count, conv_id } = props;
  const member = members && members[item.user.id];
  const is_msg_admin = member && member.role === GROUP_ROLES.ADMIN;
  const name = member ? member.name : item.user.name;
  const photo = member ? member.photo : item.user.photo;
  const member_order = member ? member.order : item.user.order;
  const is_group_admin = !!(member && member.role === GROUP_ROLES.ADMIN);
  const show_unread_bar = item.id === last_read_msg_id && messages[index - 1] ? unread_count : 0;

  const new_item = item.type && item.type.includes('UPLOAD') ? getProgress(item, conv_id, props.uploads) : item;
  return (
    <BaseMsg
      is_group={is_group}
      is_admin={is_group_admin}
      is_msg_admin={is_msg_admin}
      name={name}
      photo={photo}
      member_order={member_order}
      current_msg={new_item}
      prev_msg={messages[index + 1]}
      next_msg={messages[index - 1]}
      unread_count={show_unread_bar}
      calculateOffset={calculateOffset}
    />
  );
};
const getProgress = (item, conv_id, uploads) => {
  const found = getFileFromUploadsGroup(uploads, item.id, item.id);
  if (!found) {
    return item;
  }
  return { ...item, conv_id, file: found };
};
class BaseMsg extends PureComponent {
  _setRef = ref => {
    this.msgRef = ref;
  };

  onlayout = e => {
    const { current_msg, calculateOffset } = this.props;
    calculateOffset && calculateOffset(current_msg.index, e.nativeEvent.layout.height);
  };

  render() {
    const { prev_msg, current_msg } = this.props;
    const { scrollToOffset, unread_count, onLayout, ...props } = this.props;
    let prev_msg_time = new Date(prev_msg && prev_msg.created);
    let current_msg_time = new Date(current_msg.created);
    const Comp = all_types[current_msg.type] ? all_types[current_msg.type] : all_types['TEXT'];
    return (
      <View onLayout={this.onlayout}>
        {!isSameDay(prev_msg_time, current_msg_time) ? (
          <View style={styles.time}>
            <TimeStamp value={current_msg.created} style={{ color: theme.gray_color }} only_day />
          </View>
        ) : null}
        <Comp {...props} />
        {unread_count ? (
          <View style={styles.unread_bar}>
            <Text style={styles.unread_text}>
              {unread_count} {lang.UNREAD_MESSAGES}{' '}
            </Text>
          </View>
        ) : null}
      </View>
    );
  }
}

export default renderMsg;



// WEBPACK FOOTER //
// ./src/components/middle/chat/render_msg.js